import React, { useState } from 'react';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { Calendar, Users, Mail, Phone, User, Send } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { content } from '../mock';
import { toast } from 'sonner';

export const ContactForm = () => {
  const { language } = useLanguage();
  const t = content[language];
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    checkIn: '',
    checkOut: '',
    guests: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock form submission
    console.log('Form submitted:', formData);
    toast.success(t.formSuccess);
    setFormData({
      name: '',
      email: '',
      phone: '',
      checkIn: '',
      checkOut: '',
      guests: '',
      message: ''
    });
  };

  return (
    <div className="pb-6 mb-6 border-b">
      <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
        <Mail className="h-5 w-5" />
        {t.contactFormTitle}
      </h3>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="name" className="flex items-center gap-2">
            <User className="h-4 w-4" />
            {t.namePlaceholder}
          </Label>
          <Input
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder={t.namePlaceholder}
            required
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="email" className="flex items-center gap-2">
            <Mail className="h-4 w-4" />
            {t.emailPlaceholder}
          </Label>
          <Input
            id="email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            placeholder={t.emailPlaceholder}
            required
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="phone" className="flex items-center gap-2">
            <Phone className="h-4 w-4" />
            {t.phonePlaceholder}
          </Label>
          <Input
            id="phone"
            name="phone"
            type="tel"
            value={formData.phone}
            onChange={handleChange}
            placeholder={t.phonePlaceholder}
          />
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-2">
            <Label htmlFor="checkIn" className="flex items-center gap-2 text-xs">
              <Calendar className="h-3 w-3" />
              {t.checkInLabel}
            </Label>
            <Input
              id="checkIn"
              name="checkIn"
              type="date"
              value={formData.checkIn}
              onChange={handleChange}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="checkOut" className="flex items-center gap-2 text-xs">
              <Calendar className="h-3 w-3" />
              {t.checkOutLabel}
            </Label>
            <Input
              id="checkOut"
              name="checkOut"
              type="date"
              value={formData.checkOut}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label htmlFor="guests" className="flex items-center gap-2">
            <Users className="h-4 w-4" />
            {t.guestsLabel}
          </Label>
          <Input
            id="guests"
            name="guests"
            type="number"
            min="1"
            max="8"
            value={formData.guests}
            onChange={handleChange}
            placeholder="1-8"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="message">
            {t.messagePlaceholder}
          </Label>
          <Textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder={t.messagePlaceholder}
            rows={4}
            required
          />
        </div>

        <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700">
          <Send className="h-4 w-4 mr-2" />
          {t.sendButton}
        </Button>
      </form>
    </div>
  );
};
